

/// <reference path="IntegratorSyncEntityQueue.ts" />

// Generated class IntegratorRawQueue_ManagedObject

class IntegratorRawQueue_ManagedObject extends IntegratorSyncEntityQueue
{
}
